import { useEffect, useState } from "react";
import './ProductDetails.scss'
import { BsHandbagFill } from "react-icons/bs";
import star from '../Components/images/star.svg'
import { FaRegHeart } from "react-icons/fa6";
import { CiDeliveryTruck } from "react-icons/ci";
// Remix Icons for Variant 15 (Corner Accent Design)
import { 
    RiCheckboxCircleFill, 
    RiShieldCheckFill, 
    RiPlantFill, 
    RiTruckFill, 
    RiCustomerService2Fill, 
    RiGiftFill,
    RiErrorWarningFill
} from "react-icons/ri";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useProfile } from "../Contexts/ProfileContext";
import { getDeliveryEstimate, getUserPincode } from "../api/delivery";
import { useToast } from "../Contexts/ToastContext";

export function ProductDetails({ product_id }) {

    // console.log('star - ', star);
    const [pincode, setPincode] = useState('');
    const [pincodeError, setPincodeError] = useState('');
    const [isPincodeValid, setIsPincodeValid] = useState(false);
    const [deliveryDays, setDeliveryDays] = useState(null);
    const [deliveryDate, setDeliveryDate] = useState(null);

    // LocalStorage key for saved pincode
    const PINCODE_STORAGE_KEY = 'savedPincode';

    // Function to get appropriate icon based on feature text (Variant 15 - Remix Icons)
    const getFeatureIcon = (featureText) => {
        const text = featureText.toLowerCase();
        if (text.includes('quality')) {
            return <RiCheckboxCircleFill className="serviceabilityIcon" />;
        } else if (text.includes('payment') || text.includes('secure')) {
            return <RiShieldCheckFill className="serviceabilityIcon" />;
        } else if (text.includes('eco') || text.includes('friendly')) {
            return <RiPlantFill className="serviceabilityIcon" />;
        } else if (text.includes('delivery') || text.includes('fast')) {
            return <RiTruckFill className="serviceabilityIcon" />;
        } else if (text.includes('support') || text.includes('customer')) {
            return <RiCustomerService2Fill className="serviceabilityIcon" />;
        } else if (text.includes('loyalty') || text.includes('rewards')) {
            return <RiGiftFill className="serviceabilityIcon" />;
        }
        // Default icon
        return <RiCheckboxCircleFill className="serviceabilityIcon" />;
    };
    const [initialPincode, setInitialPincode] = useState('');
    const [productDetails, setProductDetails] = useState({})
    const [selectedButton, setSelectedButton] = useState(null)
    const [selectedQty, setSelectedQty] = useState(1)
    const [averageRating, setAverageRating] = useState([])
    const navigate = useNavigate();
    const { showToast } = useToast();
    const { fetchProfile } = useProfile();

    async function fetchProductSpecifications() {
        try {
            const token = localStorage.getItem("token");
            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const response = await axios.post(
                `/products/specifications/${product_id}`,
                {},
                config
            );

            let data = response.data;
            console.log('response data - ', data);

            if (data?.['rating-meta']?.ratings_average) {
                console.log('check ratings_average - ', data?.['rating-meta']?.ratings_average);

                setAverageRating(new Array(Math.ceil(data?.['rating-meta']?.ratings_average)).fill().map(() => "default"))
            }

            setProductDetails({ ...data })
        }
        catch (error) {
            console.error("Failed to fetch products:", error);
        }
    }

    console.log('averageRating - ', averageRating);

    // Validate and save pincode via delivery API (called when CHANGE is clicked)
    async function updatePincodeApi() {
        const val = pincode.trim();
        setPincodeError('');
        setIsPincodeValid(false);
        setDeliveryDays(null);
        setDeliveryDate(null);
        if (val.length !== 6) {
            setPincodeError('Please enter a 6-digit pincode.');
            return;
        }
        try {
            const result = await getDeliveryEstimate(val);
            if (result.serviceable && result.message) {
                setPincodeError('');
                setIsPincodeValid(true);
                setDeliveryDate(result.message);
                setDeliveryDays(result.estimatedDays ?? null);
                try {
                    localStorage.setItem(PINCODE_STORAGE_KEY, val);
                } catch (_) { /* ignore */ }
            } else {
                setPincodeError(result.message || "We don't deliver to this pincode yet.");
            }
        } catch (error) {
            console.error("Failed to update pincode:", error);
            setPincodeError('Unable to check delivery. Try again.');
        }
    }

    // Load pincode on mount: logged-in => user profile; else localStorage. Then run delivery estimate.
    useEffect(() => {
        let cancelled = false;
        async function load() {
            const token = localStorage.getItem('token');
            const savedPincode = localStorage.getItem(PINCODE_STORAGE_KEY);
            let pincodeToUse = savedPincode;
            if (token) {
                const user = await getUserPincode();
                if (user.pincode && /^\d{6}$/.test(String(user.pincode))) {
                    pincodeToUse = String(user.pincode);
                }
            }
            if (cancelled) return;
            if (pincodeToUse) {
                setPincode(pincodeToUse);
                setInitialPincode(pincodeToUse);
                const result = await getDeliveryEstimate(pincodeToUse);
                if (cancelled) return;
                if (result.serviceable && result.message) {
                    setPincodeError('');
                    setIsPincodeValid(true);
                    setDeliveryDate(result.message);
                    setDeliveryDays(result.estimatedDays ?? null);
                } else {
                    setPincodeError('');
                    setIsPincodeValid(false);
                    setDeliveryDate(null);
                }
            }
            fetchProductSpecifications();
        }
        load();
        return () => { cancelled = true; };
    }, []);


    async function addToCart() {
        try {
            const isGuest = localStorage.getItem('guestUser') === 'true';
            if (!isGuest && !localStorage.getItem("token")) {
                showToast({
                    message: 'Please login to add items to cart',
                    variant: 'info',
                    action: { label: 'Login', onClick: () => navigate('/auth/login') },
                });
                return;
            }
            if (selectedButton === null) {
                return;
            }
            const filteredSize = Object.keys(productDetails?.['size']).filter((key, index) => index === selectedButton);
            const selectedSizeKey = filteredSize[0];

            if (isGuest) {
                const guestCart = JSON.parse(localStorage.getItem('guestCart') || '[]');
                const existingIndex = guestCart.findIndex((c) => String(c.product_id) === String(product_id));
                if (existingIndex >= 0) {
                    guestCart[existingIndex].selectedQty = (guestCart[existingIndex].selectedQty || 0) + selectedQty;
                } else {
                    const productSizes = productDetails?.size || { [selectedSizeKey]: 10 };
                    guestCart.push({
                        _id: `guest-cart-${Date.now()}-${product_id}`,
                        product_id,
                        urls: productDetails?.urls || [],
                        title: productDetails?.title || 'Product',
                        price: productDetails?.price,
                        brand: productDetails?.brand,
                        mrp: productDetails?.mrp,
                        selectedSize: selectedSizeKey,
                        selectedQty,
                        size: productSizes,
                        availableSizes: Object.keys(productSizes).filter(s => productSizes[s] > 0) || [selectedSizeKey],
                        availableQuantities: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
                        maxStock: productSizes[selectedSizeKey] || 10
                    });
                }
                localStorage.setItem('guestCart', JSON.stringify(guestCart));
                window.dispatchEvent(new CustomEvent('guestCartUpdated'));
                navigate('/cart');
                return;
            }

            const token = localStorage.getItem("token");
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const pincodeToSend = (pincode && pincode.length === 6 && /^\d{6}$/.test(pincode.trim())) ? pincode.trim() : '';

            const response = await axios.post(
                `/cart/${product_id}`,
                { selectedSize: selectedSizeKey, selectedQty, pincode: pincodeToSend },
                config
            );

            try {
                await fetchProfile();
            } catch (profileError) {
                console.error('Failed to refetch profile data:', profileError);
            }
            navigate('/cart');
        }
        catch (error) {
            console.error("Failed to add to cart:", error);
            showToast({ message: 'Failed to add item to cart. Please try again.' });
        }
    }

    function selectButton(buttonIndex) {
        setSelectedButton(buttonIndex);
        const sizeKeys = productDetails?.size ? Object.keys(productDetails.size) : [];
        const key = sizeKeys[buttonIndex];
        const stock = productDetails?.size?.[key] ?? 0;
        setSelectedQty((prev) => (stock > 0 && prev > stock ? stock : prev));
    }

    const sizeKeys = productDetails?.size ? Object.keys(productDetails.size) : [];
    const selectedSizeKey = selectedButton != null && sizeKeys[selectedButton] != null ? sizeKeys[selectedButton] : null;
    const maxQty = selectedSizeKey != null ? (productDetails?.size?.[selectedSizeKey] ?? 0) : 0;
    const canDecrement = selectedQty > 1;
    const canIncrement = selectedQty < maxQty && maxQty > 0;
    const isLowStock = maxQty > 0 && maxQty < 10;

    function incrementQty() {
        if (canIncrement) setSelectedQty((prev) => prev + 1);
    }
    function decrementQty() {
        if (canDecrement) setSelectedQty((prev) => prev - 1);
    }

    // Clamp quantity when max stock changes (e.g. size change or product load)
    useEffect(() => {
        setSelectedQty((prev) => (maxQty > 0 && prev > maxQty ? maxQty : prev));
    }, [maxQty]);

    // Simple input handler - no validation while typing
    const handleInputChange = (event) => {
        const value = event.target.value;
        setPincode(value);
        // Clear previous validation states when user types
        setPincodeError('');
        setIsPincodeValid(false);
        setDeliveryDays(null);
        setDeliveryDate(null);
    };

    console.log('initialPincode - ', initialPincode);


    return (
        <div className="product-details">
            <div className="price-info">
                <h1 class="title">{productDetails?.subcategory}</h1>
                <h1 class="name">{productDetails?.title}</h1>

                <div className="rating-container">
                    <div className="overall-rating">
                        <div>{productDetails?.['rating-meta']?.ratings_average}</div>
                        <span className="myntraweb-sprite"></span>
                        <span className="myntraweb-sprite"></span>
                        <span className="myntraweb-sprite"></span>
                        <div className="total_ratings">({productDetails?.['rating-meta']?.total_ratings_count} Ratings)</div>
                    </div>
                </div>

                <div className="discount-container">
                    <div className="price">₹{productDetails?.price}</div>
                    <div className="mrp">MRP <s>{productDetails?.mrp}</s></div>
                    <div className="discount">(74% OFF)</div>
                </div>

                {/* <div className="vat-info">Inclusive of all taxes</div> */}

            </div>

            <div className="other-details">
                <div className="quantity-button-container">
                    <div className="header">
                        <h4 class="size-buttons-select-size">
                            SELECT SIZE
                        </h4>
                    </div>

                    <div className="buttons">
                        {/* <div className="button">
                            S
                        </div>
                        <div className="button">
                            M
                        </div>
                        <div className="button">
                            L
                        </div>
                        <div className="button">
                            XL
                        </div>
                        <div className="button">
                            XXL
                        </div>
                        <div className="button">
                            XXL
                        </div> */}
                        {
                            productDetails?.size &&
                            Object.keys(productDetails?.['size']).map((key, buttonIndex) => {
                                const stock = productDetails.size[key] ?? 0;
                                const isDisabled = stock === 0;
                                const isLowStock = stock > 0 && stock < 10;
                                const isSelected = selectedButton === buttonIndex;
                                return (
                                    <div
                                        key={buttonIndex}
                                        className={
                                            isSelected
                                                ? 'button size-buttons-size-button-selected'
                                                : isDisabled
                                                    ? 'button disabled-button'
                                                    : 'button'
                                        }
                                        onClick={() => !isDisabled && selectButton(buttonIndex)}
                                        style={{ cursor: isDisabled ? 'not-allowed' : 'pointer' }}
                                    >
                                        <span className="size-label">{String(key).toUpperCase()}</span>
                                        {isLowStock && !isDisabled && (
                                            <span className="stock-indicator">{stock} left</span>
                                        )}
                                    </div>
                                );
                            })
                        }
                    </div>
                </div>

                <div className="quantity-row">
                    <div className="header">
                        <h4 className="quantity-row-label">Quantity</h4>
                    </div>
                    <div className="quantity-controls">
                        <button
                            type="button"
                            className="qty-btn qty-minus"
                            onClick={decrementQty}
                            disabled={!canDecrement}
                            aria-label="Decrease quantity"
                        >
                            −
                        </button>
                        <span className="qty-value" aria-live="polite">{selectedQty}</span>
                        <button
                            type="button"
                            className="qty-btn qty-plus"
                            onClick={incrementQty}
                            disabled={!canIncrement}
                            aria-label="Increase quantity"
                        >
                            +
                        </button>
                    </div>
                    {isLowStock && maxQty > 0 && (
                        <span className="quantity-row-stock">Only {maxQty} left</span>
                    )}
                </div>

                <div className="action-container">
                    <div className="add-to-list" onClick={() => addToCart()}>
                        <span>
                            <BsHandbagFill width={150} height={150} />
                        </span>
                        ADD TO BAG
                    </div>
                    <div className="wishlist">
                        <span className="wishlist-icon-wrap">
                            <FaRegHeart className="wishlist-icon" />
                        </span>

                        {/* <span>
                            WISHLIST
                        </span> */}
                    </div>
                </div>

                <div className="pincode-delivery-container variant-15">
                    <span>
                        <h5>
                            Delivery Check
                        </h5>
                        <span>
                            <CiDeliveryTruck />
                        </span>
                    </span>

                    <div className="pincode-input-container">
                        <input placeholder="Enter pincode" className="pincode-code" name="pincode"
                            type="text"
                            inputMode="numeric"
                            pattern="\d*"
                            autocomplete="pincode"
                            maxlength="6"

                            value={pincode}
                            onChange={(e) => {
                                const value = e.target.value;
                                if (/^\d*$/.test(value)) { // Only allow digits
                                    handleInputChange(e); // Call the handler with the valid input
                                }
                            }}
                        />
                        {/* <input type="tel" className="pincode-check pincode-button" value="Check" fdprocessedid="uphqfb" onClick={() => updatePincode()} /> */}
                        <span className="Address-address-button" onClick={() => updatePincodeApi()}>CHANGE</span>
                    </div>
                    <ul className="pincode-serviceability-list">
                        {pincode.length === 6 && isPincodeValid && deliveryDate && (
                            <li className="pincode-serviceabilityItem">
                                <RiTruckFill className="serviceabilityIcon" />
                                <h4 className="pincode-serviceabilityTitle">{deliveryDate}</h4>
                            </li>
                        )}
                        {pincode.length === 6 && !isPincodeValid && pincodeError && (
                            <li className="pincode-serviceabilityItem">
                                <RiErrorWarningFill className="serviceabilityIcon" style={{ color: '#ef4444' }} />
                                <h4 className="pincode-serviceabilityTitle" style={{ color: '#ef4444' }}>{pincodeError}</h4>
                            </li>
                        )}
                    </ul>

                    <ul className="product-features">
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Assured On Quality")}
                            <h4 class="pincode-serviceabilityTitle">Assured On Quality</h4>
                        </li>
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Secure Payment Options")}
                            <h4 class="pincode-serviceabilityTitle">Secure Payment Options</h4>
                        </li>
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Eco-Friendly Practices")}
                            <h4 class="pincode-serviceabilityTitle">Eco-Friendly Practices</h4>
                        </li>
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Fast Delivery Options")}
                            <h4 class="pincode-serviceabilityTitle">Fast Delivery Options</h4>
                        </li>
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Customer Support")}
                            <h4 class="pincode-serviceabilityTitle">Customer Support</h4>
                        </li>
                        <li class="pincode-serviceabilityItem">
                            {getFeatureIcon("Loyalty Rewards")}
                            <h4 class="pincode-serviceabilityTitle">Loyalty Rewards</h4>
                        </li>
                    </ul>
                    {/* <p className="pincode-enterPincode">Please enter PIN code to check delivery time &amp; Pay on Delivery Availability</p> */}
                </div>

            </div>

        </div>
    )
}